import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
//assets/svg/logo-udd-blanco.svg
import logoUDD from '../../assets/svg/logo-udd-blanco.svg';
import logoM from '../../assets/dist/svg/main.svg';
type Props = {
    mostrarCallCenter: boolean;
}
const HeaderInicio: React.FC<Props> = ({ mostrarCallCenter }) => {
    const history = useHistory();
    const location = useLocation();
    const [nombrePostulante, setNombrePostulante] = useState('');
    const [codCarr, setCodCarr] = useState('');
    const [nombreCarrera, setNombreCarrera] = useState('');
    const [sede, setSede] = useState('');
    const [cabecera, setCabecera] = useState('');
    const [fase, setFase] = useState('')
    const [descripcion, setDescripcion] = useState(false)

    const handleBorrarSession = () => {
        sessionStorage.removeItem('stage');
        sessionStorage.removeItem('stageRut');
        sessionStorage.removeItem('stageRutNumerico');
        sessionStorage.removeItem('nombreCompleto');
        sessionStorage.removeItem('codCarrera');
        sessionStorage.removeItem('codsede');
        sessionStorage.removeItem('nombreCarrera');
        sessionStorage.removeItem('fase');
    }

    useEffect(() => {
        let fs = sessionStorage.getItem('fase');
        /* console.log(nc) */
        if (fs === null) { fs = '' }

        if (fs !== '') {
            fs = fs.replace('"', '')
            fs = fs.replace('"', '')
        }
        /* console.log(fs) */
        setFase(fs)
        /* let nc = sessionStorage.getItem('stageNombreCompleto'); */
        let nc = sessionStorage.getItem('nombreCompleto');
        /* console.log(nc) */
        if (nc === null) { nc = '' }

        if (nc !== '') {
            nc = nc.replace('"', '')
            nc = nc.replace('"', '')
        }
        setNombrePostulante(nc.replace('"', ''));

        let cc = sessionStorage.getItem('codCarrera');
        /* console.log(cc) */
        if (cc === null) { cc = '' }
        if (cc !== '') {
            cc = cc.replace('"', '')
            cc = cc.replace('"', '')
        }
        if (cc === null) { cc = '' }
        setCodCarr(cc);

        let nmc = sessionStorage.getItem('nombreCarrera');
        if (nmc === null) { nmc = '' }
        if (nmc !== '') {
            nmc = nmc.replace('"', '')
            nmc = nmc.replace('"', '')
        }
        setNombreCarrera(nmc);

        let se = sessionStorage.getItem('codsede');
        if (se === null) { se = '' }
        if (se !== '') {
            se = se.replace('"', '')
            se = se.replace('"', '')
        }
        setSede(se);

        setCabecera(/* ' - ' + cc +  ' - ' +*/ nmc + ' - ' + (se === "CONCEPCION" ? "CONCEPCIÓN" : se));

    }, [])

    return (
        <>
            <header style={{ position: 'fixed', display: 'grid', zIndex: 99, height: '6rem' }} className="site-header">
                <title>Matrícula Web Universidad Del Desarrollo</title>
                <meta name='description' content='Proceso de Matrícula Web Universidad Del Desarrollo.'></meta>
                <div className="site-header__container2">
                    <div style={{ display: 'flex' }}>

                        {
                            descripcion ?
                                ''
                                :
                                <div>
                                    <img style={{ marginLeft: '2rem', marginTop: '1rem' }} src={logoUDD} alt="Logo Universidad de Desarrollo" className="site-header__logo" />
                                </div>
                        }

                        {/* <div style={{ marginLeft: '2rem' }} className="enrollment-header__title2">
                        <span>Matrícula en Línea</span></div> */}
                        {
                            mostrarCallCenter ?
                                <div className="site-footer__callcenter_privado">
                                    <span className="site-footer__contact__label_privado">Call Center:</span>
                                    <a href="tel:800200125" className="callCenter_privado">800 200 125</a>
                                </div>
                                :
                                ""
                        }

                        {/*  */}</div>

                </div>

            </header>

            <br></br>
            <br></br>
            <br></br>
        </>
    );
}

export default HeaderInicio;